export const demoData = {
  version: 1.0,
  title: "ComputerTalk Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Login to iceBar",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "With ice Contact Center, agents can easily answer incoming customer interactions in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image1.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view begins in a Teams channel titled Process Improvement. In a thread, Megan Bowen has sent a .gif of dogs clapping and a message that reads “Great teamwork!” In the same thread, Nestor Wilke has responded “This is awesome!” and “Megan Bowen great job!”",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Click on the icon to open the iceBar chat and iceManager tools",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: ".95%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image2.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, the focus is on the bar to the left of the screen. There are ten vertically aligned icons. Activity, Chat, Teams, Calendar, Calls, Files, ice, and an ellipsis icon are on the top, and the app store and help icons are at the bottom. A purple pop-up points to the ice icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Type “Status” to view or modify your status",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image3a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the ice icon, and the view has changed to the ice bot. The bot window shows a card summarizing a previous chat with a customer. A purple pop-up points to the chat box at the bottom of the screen.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click the “Logon” button to sign into the queues",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81%",
              x: "39.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image2.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: ['ComputerTalk_Step1a_Image3a.jpg', 'ComputerTalk_Step1a_Image3b.jpg', 'ComputerTalk_Step1a_Image3b.jpg', 'ComputerTalk_Step1a_Image3c.jpg',  'ComputerTalk_Step1a_Image3c.jpg', 'ComputerTalk_Step1a_Image4.jpg', 'ComputerTalk_Step1a_Image4.jpg', 'ComputerTalk_Step1a_Image5.jpg']
          },
          screenReaderText: "In the same view, the user types “Status” into the chat box. A purple pop-up points to the send icon under the chat box. The user has clicked the send icon, and sent the “Status” message to the ice chat bot. The ice bot has sent a card summarizing Megan Bowen’s status into the chat thread. It reads “Here’s your current ice status” at the top of the card. In the center of the card there’s a lock icon, and text that reads “Megan Bowen (1009) Logged Off since 10:31:45 AM as of 11:19:47 AM”. A purple pop-up points to a button on the card that says Logon.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Check the “All queues” box and click submit",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50.6%",
              x: "26.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image6a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: []
          },
          screenReaderText: "The user has clicked the logon button. The chat is now in the background, and a new box has appeared listing the available queues. A vertically oriented list reads All queues, Chat queue (6000), Voice queue (7000), and Email queue (8000). There is a checkbox next to each queue, and a purple pop-up points to All queues.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "63.2%",
              x: "69.85%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image6b.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: []
          },
          screenReaderText: "In the same view, the user has clicked the box next to All queues, and a purple pop-up points to a Logon button on the box. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Once an agent is logged on, customer calls in the queue can be routed to them. Agents also have the option to select a “Not Ready” status.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "69.85%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image7.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: []
          },
          screenReaderText: "The user has clicked Logon, and the view has returned to the ice chat. The status card has been updated to read “Megan Bowen (1009) Ready since 11:19:52 AM as of 11:19:52 AM”. There are six buttons at the bottom of the card. Refresh, Not Ready, Logon, Logoff, Start Contact, and an ellipsis. A purple box outlines Not Ready.",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Manage incoming customer calls",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Select the answer icon to begin the call",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "11.1%",
              x: "91.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image9.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view is in the ice chat. In the upper right-hand corner of the screen, there is a call notification from +1 555-414-1298 Erin Johnson. The notification has two buttons under the phone number and name, an answer and a hang up icon. A purple pop-up points to the answer icon. The status card has also been updated to “Alerting”, and another card has appeared in the chat with some of the caller’s information.",
        },
        // {
        //   id: 2,
        //   card: {
        //     transition: false,
        //     text: "Agents can place calls on hold, transfer, or consult from the Contact tab on the call card within iceBar.",
        //     snack: {
        //       isVisible: true,
        //       position: "left",
        //     },
        //     position: {
        //       y: "84%",
        //       x: "91.5%",
        //     },
        //     beacon: {
        //       isVisible: true,
        //       position: "right",
        //     },
        //   },
        //   images: {
        //     name: ["ComputerTalk_Step1a_Image10.jpg"],
        //     imageAltText: "Microsoft Teams desktop user interface",
        //     sequence: false,
        //   },
        //   screenReaderText: "The view has changed to a call. There’s an avatar in the middle of the screen, and a horizontally oriented bar at the bottom with a time tracker and five icons—a microphone, dial pad, ellipses, participants, and a hang up symbol.",
        // },
        {
          id: 3,
          card: {
            transition: false,
            text: "End the call when the conversation is finished",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "90.5%",
              x: "58.65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image11.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple pop-up points to the hang up icon.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "After the call, ice will send the agent a chat message with summary information.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "84%",
              x: "91.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image12a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the hang-up icon to end the call, and the view has changed to a call history showing the most recent call highlighted at the top of the screen. There’s a notification in the upper right-hand corner of the screen that ice has sent a card.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Head back to icebar to view a card with the call summary",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39.5%",
              x: "0.95%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image12a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple pop-up points to the ice icon on the left-side rail.",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Agents will be automatically placed into a wrap up stage after a call in order to take notes and prepare for the next interaction. This is an optional step, and the amount of time an agent spends in wrap-up is configurable.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "76%",
              x: "0.95%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1a_Image13.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view has changed to the ice bot chat. There is a card in the chat indicating that the call has ended, as well as a new status  card from Megan Bowen (1009). The icon in the card is a green square and reads “Ready since 11:36 AM”. ",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Chat live with customers",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Customer requests for online chat support are routed to the ice Contact Center queue and sent to the next available agent.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image1.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view is of the ice bot chat. There are two cards visible in the chat thread. One detailing Megan Bowen’s status as Active, and a second card notifying the user of an incoming chat.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "View the chat notification in the ice card, including previous contacts",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "67%",
              x: "54.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image2a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple box outlines the chat notification card.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Head to Chat, or click the “Open Chat” button from the ice card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "11%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image2b.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "A purple pop-up points to the chat icon on the left side bar.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Type your message to the customer",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image3.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view has changed to the Teams chat view. The left side of the screen shows a vertical list of all the user’s chats with preview text for each thread. The user has clicked the chat at the top of the list, showing a chat with mike_icemessaging-50@contoso.com. A purple pop-up points to the chat bar in the window.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "96%",
              x: "81.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image3.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: ['ComputerTalk_Step1b_Image4a.jpg', 'ComputerTalk_Step1b_Image4b.jpg', 'ComputerTalk_Step1b_Image4c.jpg', 'ComputerTalk_Step1b_Image4d.jpg', 'ComputerTalk_Step1b_Image4e.jpg', 'ComputerTalk_Step1b_Image4f.jpg', 'ComputerTalk_Step1b_Image4g.jpg', 'ComputerTalk_Step1b_Image4h.jpg', 'ComputerTalk_Step1b_Image4i.jpg']
          },
          screenReaderText: "The user types “Hi Mike, thanks for reaching out. How can I help?” into the chat box. A purple pop-up points to the send icon under the chat bar. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Agents can also access pre-written responses for quick replies in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image5a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the send icon, and “Hi Mike, thanks for reaching out. How can I help?” is now part of the chat thread.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Once the conversation is finished, go back to iceBar to complete your wrap up tasks",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image5a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple pop-up now points to the ice icon on the left-hand rail.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "When the conversation is over, ice will update the card within icebar with summary information.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image6.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view has returned to the ice chat, and a purple box highlights the card in the chat detailing previous chat with Mike. Below the chat card, there’s a status card indicating Megan Bowen (1009) is ready.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Once the chat is closed, agents can post a contact record to a Teams channel to share information and collaborate on support solutions.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image7a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Click the ellipsis on the ice summary card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60.2%",
              x: "39.53%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image7b.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, the focus is on the card detailing the previous chat with Mike. There are two buttons at the bottom of the card: “Open Chat” and an ellipsis. A purple pop-up points to the ellipsis.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Click the “Add to Team” button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "60%",
              x: "41.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image8.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the ellipsis button, and three more buttons have appeared at the bottom of the card- Delete Card, Add to Team, and iceJournal. A purple pop-up points to Add to Team.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Select the appropriate Team and Channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "47.8%",
              x: "71.35%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image9.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Add to Team button, and a box has appeared that reads Select Team with a dropdown that reads Select and option. A purple pop-up points to a carrot that will open a drop-down menu. Under the dropdown, there’s a button that reads Select team.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "58.3%",
              x: "27%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image10a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has expanded the dropdown. The list of options reads Contoso, Sales and Marketing, Digital Initiative Public Relations, Support Team, and Retail. A purple pop-up points to Support Team.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "52.3%",
              x: "69%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image10b.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, Support Team has been selected, and a purple pop-up points to the Select Team button.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "47.7%",
              x: "71.33%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image11.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a new box has appeared that reads Select Channel with a dropdown that reads Select and option. A purple pop-up points to a carrot that will open a drop-down menu. Under the dropdown, there’s a button that reads Select Channel.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "54%",
              x: "27%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image12.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has expanded the dropdown. The list of options reads General, Troubleshooting, Process Improvement, Customer Feedback, and For Fun. A purple pop-up points to Troubleshooting.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "52.2%",
              x: "68.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image13.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, Troubleshooting has been selected, and a purple pop-up points to the Select Team button.",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Head to the channel to start collaborating with your team",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "17%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image14.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Select Team button, and the view has returned to the ice chat. A purple pop-up points to the Teams icon on the left-side rail. ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85.5%",
              x: "36.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image15.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Teams icon, and the view has changed to the Troubleshooting channel nested under the Support Team. A purple box outlines the card detailing the chat with Mike that was just added to the channel. A purple pop-up points to a chat box below the card.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85.8%",
              x: "85.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image16.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: ['ComputerTalk_Step1b_Image15.jpg', 'ComputerTalk_Step1b_Image16a.jpg', 'ComputerTalk_Step1b_Image16b.jpg', 'ComputerTalk_Step1b_Image16c.jpg', 'ComputerTalk_Step1b_Image16d.jpg', 'ComputerTalk_Step1b_Image16e.jpg']
          },
          screenReaderText: "The user has typed “Hey @Nestor, can you help me with this follow up?” into the chat box, and a purple pop-up points to a send icon below the chat box. ",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85%",
              x: "1%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1b_Image17.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, the user has clicked the send icon, and the message now appears below the card. ",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Respond to customer emails",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "When agents are signed into Outlook, they can respond to customer emails directly in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image1.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view has returned to the ice chat, and there is a card detailing an email interaction with a customer named William Brown. His email message reads “I’m having a hard time getting the Bluetooth to work on my printer. Please advise”. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "View the email notification card in ice, which displays the customer’s contact information and message",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "59%",
              x: "53.6%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image2.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple box outlines the email card.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the Outlook button to launch Outlook in Teams and respond to the customer email",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.4%",
              x: "35.45%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image3.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "At the bottom of the email card, there are 6 buttons: Outlook, Reply, Refresh, Contact Controls, Agent Controls, and an ellipsis. A purple box outlines the Outlook button.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Select the “Reply” button to respond directly in the ice card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "79.6%",
              x: "39.25%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image4.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple pop-up points to the Reply button on the email card.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "71%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image5a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Reply button, and an email box has appeared at the bottom of the card. There’s a Subject field, a Reply here” field with a purple pop-up, and a Reply button. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81.8%",
              x: "33.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image5a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: ['ComputerTalk_Step1c_Image5a.jpg', 'ComputerTalk_Step1c_Image5b.jpg', 'ComputerTalk_Step1c_Image5c.jpg', 'ComputerTalk_Step1c_Image5d.jpg', 'ComputerTalk_Step1c_Image5e.jpg', 'ComputerTalk_Step1c_Image5f.jpg', 'ComputerTalk_Step1c_Image5g.jpg', 'ComputerTalk_Step1c_Image5h.jpg', 'ComputerTalk_Step1c_Image5i.jpg', 'ComputerTalk_Step1c_Image6.jpg']
          },
          screenReaderText: "The user has typed “Hi William, I’m happy to help! Let me check this out. I’ll get back to you shortly!”  into the reply box. In the same view, a purple pop-up points to the Reply button.",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Choose Contact Controls to send the email to another agent",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83%",
              x: "35%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image7.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Reply button, and the focus has returned to the email card in the ice chat. A purple pop-up now points to the Contact Controls button.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Select the Transfer button and use the drop-down menu to choose the appropriate agent",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "41.25%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image8.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Transfer button, and three new buttons have appeared on the card: See User Data, Transfer, and Release. A purple pop-up points to the Transfer button.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "78%",
              x: "54%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image9.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82%",
              x: "36.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image10.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, the user has clicked the Transfer button, and a new dropdown has appeared on the card that reads ice users. 1001-Grady (Ready) is currently selected, and a purple pop-up points to a button to expand the drop-down.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82.7%",
              x: "34%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image11.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, the user has expanded the dropdown, and the vertical list reads 1009-Miriam (On Email), 1001 – Grady (Ready), and 9999-Mark (Not Ready). A purple pop-up points to 1001-Grady (Ready). 1001-Grady (Ready) is still selected, and a purple pop-up points to a Transfer button below the drop down.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "To help manage customer interactions, agents can access customer contact records through iceJournal.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image12.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Transfer button, and the view has returned to the email card.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Select the ellipses in the ice card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83%",
              x: "49.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image12.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "On the chat card, a purple pop-up points to the ellipsis button.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "Choose the iceJournal button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83%",
              x: "34%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image14.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the ellipsis, and a new button has appeared below the ellipsis that reads iceJournal, with a purple pop-up pointing to it.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "View a detailed list of customer interactions by type",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "23.2%",
              x: "54%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image15.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the iceJournal button, and the view has changed to the iceJournal view. The screen shows filtering options on the left. The main screen shows a vertical list with one line for the email interaction with william@fabrikam.com, highlighted with a purple box.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "If ice is connected to a CRM, users can view interaction records for specific contacts.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step1c_Image16.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Manage support queues and agents",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "With iceManager, supervisors can monitor queues, view agent status, and move agents between queues to ensure prompt responses to customers.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image1.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The view has returned to the ice chat. There is a card detailing a previous chat, as well as a card indicating Megan Bowen’s status is ready.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "From the ice app, click on the iceManager tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "13.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image1.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "At the top of the ice chat, there’s a menu bar with three tabs: Chat, iceManager, and About. A purple pop-up points to the iceManager tab.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Login",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36%",
              x: "39%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image3a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the iceManager tab, and the view has changed to show a login box with 3 fields: Username, Password, and a language dropdown. There’s a Use Windows Credentials and Sign in button at the bottom of the login box. A purple pop-up points to the Username field.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "59.8%",
              x: "43%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image3a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: ['ComputerTalk_Step2_Image3a.jpg', 'ComputerTalk_Step2_Image3b.jpg', 'ComputerTalk_Step2_Image3c.jpg', 'ComputerTalk_Step2_Image3d.jpg', 'ComputerTalk_Step2_Image3e.jpg', 'ComputerTalk_Step2_Image3f.jpg',]
          },
          screenReaderText: "In the same view, the user has typed megan@contoso.com into the username field, as well as a password. A purple pop-up points to the Use Windows Credentials button.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Select the iceMonitor window",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "14%",
              x: "15%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image4.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has logged in, and the view has changed to the iceManager tab. Under the “iceManager” tab, there’s a horizonal bar with 8 tabs—home, iceManager, journal, survey, reports, administrator, campaign, and icebar. A purple pop-up points to iceMonitor.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Choose a queue to view a list of detailed information, including number of contacts in the queue and estimated wait time",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "38%",
              x: "23.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image5.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked iceMonitor and the view has changed to the iceMonitor tab. The page shows two vertical columns: Queues and Users. The Queue column lists three available queues: Chat queue, Voice queue, and Email queue. The Users column lists all ice users. A purple pop-up points to the Chat Queue in the queue column. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "View contacts in the queue and employees currently logged on to a specific queue",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "66.8%",
              x: "36%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image6.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked on the chat queue, and a new table has appeared under the Users column. The chart has four tabs—Information, Contacts, Logged On To Queue, Not Logged On to Queue. The Information tab is open and shows statistics on the chat queue. A purple pop-up points to the Logged On To Queue tab. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "View agent information, including name, role, and status in the users window",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "37%",
              x: "7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image7.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the logged on to queue tab, displaying a vertically oriented list of 4 users who are currently logged in. There is a vertical menu titled Monitor on the left side of the screen with 5 options: Home, Queues, Users, Teams, and Settings. A purple pop-up points to Users.",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Click on a user to display statistics, such as volume of calls answered, average call duration, and more",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "29.3%",
              x: "30.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image8.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the users option in the Monitor drop down, and the view has changed to only display the vertically oriented chart of all ice Users. A purple pop-up points to the first user on the list, Patti.",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Right click on a user to view additional manager controls, such as logging agents on and off of queues",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "29.5%",
              x: "37%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image9.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked Patti and a new chart has appeared next to the Users chart, detailing statistics on Patti. There is still a purple pop-up pointing to Patti in the Users chart.",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Join calls to monitor and coach agents",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "37%",
              x: "38.6%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image10.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked Patti again, and a dropdown has appeared under her name that reads Log on to ice, Call User, Monitor User, and Coach User.",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Select the Journal tab within iceManager to view previous agent and customer interactions",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "13.8%",
              x: "20.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image11.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "A purple pop-up now points to the Journal tab near the top of the screen.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Use the filters to narrow your search and click the update button to view results",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "40%",
              x: "16%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image12a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Journal tab and the view has changed to the Journal view. The focus is on a wide bar on the left side of the screen listing filtering options. A purple box highlights a portion of the menu titled Interaction Type. There are 3 options (Voice, Email, and Instant Message) and a CTA button that reads Update.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "5.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image12b.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple pop-up points to Instant Message in the Interaction Type menu section.",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "44%",
              x: "11%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image13.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has checked the box next to Instant Message, and a purple pop-up now points to the Update button.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Choose an interaction in the results window to view details about the interaction",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "59%",
              x: "33%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image14.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the update button, and a list of instant message interactions has populated on the right-hand side of the screen with dates, durations, sender email addresses, user names, and queues. A purple pop-up points to the 4th interaction on the list.v",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image15.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked on 4th interaction on the list, and a Details box has appeared to the right of the results, showing details on a chat interaction between a user, Johanna, and a customer, Felicia.",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "Managers can download call recordings and view transcripts of emails and chats.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image15.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Navigate to the Reports tab to run summary and detailed reports on the contact center to guide decision making",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13.5%",
              x: "30.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image17.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "In the same view, a purple pop-up points to the Reports tab under iceManager.",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Select the Open Reports button to launch iceReporting",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "36%",
              x: "50.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image18.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Reports tab, and the view has updated to show the Reports page. There’s an image of a screen displaying a report, with a purple pop-up pointing to a CTA that reads Open reports.",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "Use the left side menu to select report type and parameters",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13.5%",
              x: "11.8%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image19a.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the Open reports CTA, and a browser window has opened for iceReporting. There is a black bar on the left side of the screen with the filtering options, and a blank gray screen on the right. A purple box outlines the filtering options.",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "5.5%",
              x: "1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image19b.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "A purple pop-up points to the first option on the Menu, User ADR.",
        },
        {
          id: 22,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "7%",
              x: "1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image20.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked User ADR, and expanded a list of 4 menu options. A purple pop-up points to the first option on the menu, User Activity Detail Record Report.",
        },
        {
          id: 23,
          card: {
            transition: false,
            text: "Select View",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "15%",
              x: "36%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image21.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked User Activity Detail Record Report, and information has not populated on the gray screen on the right-hand side. There’s a description of the information the user will find in the report, 4 CTA buttons (Change Parameters, Print, View, and Schedule) as well as a chart detailing dates, times, and users. A purple pop-up points to the View CTA. ",
        },
        {
          id: 24,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["ComputerTalk_Step2_Image22.jpg"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user has clicked the View CTA, and a User Activity detail record report has loaded on the page. ",
        },
      ],
    },
    {
      id: 6,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Get ComputerTalk ice Contact Center for Teams",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "When your organization is ready to install and activate iceBar for Teams, collaborate with the ComputerTalk integration team to configure the set up.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step3_Image1.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "The view is of the ice chat window with a card detailing a chat interaction between Megan Bowen and a customer named Erin, as well as a status card for Megan Bowen indicating she’s Ready for the next customer. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "IT administrators can pin iceBar within Teams to ensure agents and supervisors can quickly access iceBar for omnichannel communications with customers.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "79%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step3_Image1.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 7,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["ComputerTalk_Step5_end_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
